<vlaio-icon [icon]="open ? 'fa-chevron-up' : 'fa-chevron-down'" />
<ng-content />
